import { Roles } from "@qw/graphql";

export const ROLE_METADATA: Record<Roles, { label: string }> = {
  [Roles.Admin]: {
    label: "Admin",
  },
  [Roles.Agent]: {
    label: "Agent",
  },
  [Roles.Arm]: {
    label: "ARM",
  },
  [Roles.Binding]: {
    label: "Binding",
  },
  [Roles.Broker]: {
    label: "Broker",
  },
  [Roles.Dj]: {
    label: "DJ",
  },
  [Roles.UnderwritingAssistant]: {
    label: "STS",
  },
};
